module.exports = __webpack_public_path__ + "static/media/culture_05.ef3bff60.jpg";